import * as React from "react";
import { SVGProps } from "react";
const SvgFunnel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m5.002 5-.114.006c-.814.087-1.196 1.1-.593 1.701l7.707 7.708V26a1 1 0 0 0 1.447.894l6-3 .108-.062a.999.999 0 0 0 .445-.832v-8.586l7.707-7.707c.63-.63.184-1.707-.707-1.707h-22Zm19.584 2-6.29 6.293-.088.1a1 1 0 0 0-.206.607v8.381l-4 2v-10.38l-.009-.132a1 1 0 0 0-.284-.576L7.417 7h17.17Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFunnel;
